import { _ConstructorOf, Accessor, Layer, UpdateParameters } from '@deck.gl/core';
import { TextLayer } from '@deck.gl/layers';
import { HidableTextBackgroundLayer } from './background/hidable-text-background-layer';
import { HidableMultiIconLayer } from './icon/hidable-multi-icon-layer';

export class HidableTextLayer<TData = unknown, TProps = object> extends TextLayer<
    TData,
    TProps & {
        getIsHidden: Accessor<TData, 0 | 1>;
    }
> {
    protected override getSubLayerClass<T extends Layer>(subLayerId: string, defaultLayerClass: _ConstructorOf<T>): _ConstructorOf<T> {
        if (subLayerId === 'characters') {
            return HidableMultiIconLayer<TData> as any;
        } else if (subLayerId === 'background') {
            return HidableTextBackgroundLayer<TData> as any;
        }

        return defaultLayerClass;
    }

    protected override getSubLayerProps(sublayerProps?: { id?: string; updateTriggers?: Record<string, any>; [propName: string]: any }) {
        return {
            ...super.getSubLayerProps(sublayerProps),
            getIsHidden: this.props.getIsHidden
        };
    }

    getTextBounds(item: TData): [number, number, number, number] {
        const result = (this as any).getBoundingRect(item);
        const position = (this.props.getPosition as any)(item) as [number, number, number];
        const projected = this.project(position);
        result[0] = projected[0] + result[0] - this.props.backgroundPadding[0];
        result[1] = projected[1] + result[1] - this.props.backgroundPadding[1];
        result[2] = (result[2] / this.state.fontAtlasManager.props.fontSize) * (this.props.getSize as number) + 2 * this.props.backgroundPadding[0];
        result[3] = (result[3] / this.state.fontAtlasManager.props.fontSize) * (this.props.getSize as number) + 2 * this.props.backgroundPadding[1];

        return result;
    }

    protected override _postUpdate(updateParams: UpdateParameters<this>, forceUpdate: boolean): void {
        super._postUpdate(updateParams, forceUpdate);
    }
}
